import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OperationalPlanning from "./sections/OperationalPlanning";
import OurCapabilities from "./sections/OurCapabilities";
import HardwareCompatibility from "./sections/HardwareCompatibility";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <OperationalPlanning />
      <OurCapabilities />
      <HardwareCompatibility />
      <Footer />
    </div>;
}